import useAttendances from "../../../hooks/use-attendance";
import AttendanceForm from "../../../features/attendance/components/attendance-form";
import { useState } from "react";
import { BusinessAttendanceSummary, AttendanceRequest } from "../../../service/model/attendance.model";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as attendanceSlice from "../../../features/attendance/attendance.slice";
import Loader from "../../../components/loader";
import BusinessAttendanceSummaryView from "../../../features/attendance/components/business-attendance-summary";
import AttendanceTable from "../../../features/attendance/components/attendance-table";
import useAttendanceSummary from "../../../hooks/use-attendance-summary";

const BusinessAttendance = () => {
    const dispatch = useAppDispatch();
    const [showAttendanceForm, setShowAttendanceForm] = useState(false);
    const isLoading = useAppSelector(attendanceSlice.selectIsLoading);

    const [attendances] = useAttendances();
    const attendanceSummary = useAttendanceSummary();

    const handleSubmit = (data: AttendanceRequest) => {
        dispatch(attendanceSlice.createAttendance(data));
        setShowAttendanceForm(false);
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {attendances &&
                <>
                    <BusinessAttendanceSummaryView attendanceSummary= {attendanceSummary as BusinessAttendanceSummary} />
                    <AttendanceTable attendances={attendances} />
                    {showAttendanceForm &&
                        <AttendanceForm attendance={undefined} editable={true} onClose={() => setShowAttendanceForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default BusinessAttendance;